/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceTypeDetailItem } from './ServiceTypeDetailItem';
import {
    ServiceTypeDetailItemFromJSON,
    ServiceTypeDetailItemFromJSONTyped,
    ServiceTypeDetailItemToJSON,
    ServiceTypeDetailItemToJSONTyped,
} from './ServiceTypeDetailItem';

/**
 * 
 * @export
 * @interface ServiceTypeDetails
 */
export interface ServiceTypeDetails {
    /**
     * 
     */
    service_type_code?: string;
    /**
     * 
     */
    service_type_code_definition?: string;
    /**
     * 
     */
    details?: ServiceTypeDetailItem;
}

/**
 * Check if a given object implements the ServiceTypeDetails interface.
 */
export function instanceOfServiceTypeDetails(value: object): value is ServiceTypeDetails {
    return true;
}

export function ServiceTypeDetailsFromJSON(json: any): ServiceTypeDetails {
    return ServiceTypeDetailsFromJSONTyped(json, false);
}

export function ServiceTypeDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceTypeDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'service_type_code': json['service_type_code'] == null ? undefined : json['service_type_code'],
        'service_type_code_definition': json['service_type_code_definition'] == null ? undefined : json['service_type_code_definition'],
        'details': json['details'] == null ? undefined : ServiceTypeDetailItemFromJSON(json['details']),
    };
}

export function ServiceTypeDetailsToJSON(json: any): ServiceTypeDetails {
    return ServiceTypeDetailsToJSONTyped(json, false);
}

export function ServiceTypeDetailsToJSONTyped(value?: ServiceTypeDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'service_type_code': value['service_type_code'],
        'service_type_code_definition': value['service_type_code_definition'],
        'details': ServiceTypeDetailItemToJSON(value['details']),
    };
}

